import React from 'react';
import { Rect, Text, Image } from 'react-konva';
import {
  isMobileTablet,
  isMobilePhone
} from '../../library/calc';

// import {} from '../../library/constants';

const adjustTop = 25.8;
const adjustLeft = 29.25;

export const TextRectangle = ({
    n,
    node,
    nodeObj,
    left,
    top,
    canEditnode,
    onClickedInvite,
    cursorBecomesMove,
    cursorBecomesPointer,
    stopStageClickPropagation,
    userTouchedNode,
    panAnimateToNode,
    translatedLabels,
    mailIconDim,
    widthInviteContainer,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
  }) => {

    const height = 5.5;
    const width = widthInviteContainer;
    left += adjustLeft;

    top += adjustTop - 3;

  const fillLinearGradientColorStops = [0, 'white', 1, '#C0C0C0'];
  const yStartPointGradient = 0;
  const yEndPointGradient = height * 2;

  return <Rect
    x={left}
    y={top}
    width={width}
    height={height}
    cursor="pointer"
    fillLinearGradientStartPoint={{ x : width/2, y : yStartPointGradient}}
    fillLinearGradientEndPoint={{ x : width/2, y : yEndPointGradient}}
    fillLinearGradientColorStops={fillLinearGradientColorStops}

    onClick={(evt)=>{
      stopStageClickPropagation({fromWhere: 'InviteComponent C'});
      evt.cancelBubble = true;
      const prId = nodeObj.pr_id;
      onClickedInvite({node, prId});
    }}

    onTouchStart={()=>{

      userTouchedNode({
        node,
        callback: ()=>{

          if(isMobileTablet()){
            stopStageClickPropagation({fromWhere: 'InviteComponent rect'});
            const prId = nodeObj.pr_id;
            onClickedInvite({node, prId});
            return;
          }

          if(isMobilePhone() ) {
            let screenIsOn = `mainFromHome`;
            setFlipCardScreenIsOn({screenIsOn});
            setNodeForFlipFocus(node);
            setShowMobileFlipCard(node);
          }
        },
        fromWhere: 'invite rect'
      });



    }}

    onMouseenter={()=>{
      cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
    }}

  />;
};


export class IconMail extends React.Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `invite_n-${this.props.node}`, objClass: this});
  }

  click(evt){

    this.props.stopStageClickPropagation({fromWhere: 'InviteComponent A'});
    if( typeof(evt) !== 'undefined' )  evt.cancelBubble = true;
    const prId = this.props.nodeObj.pr_id;
    this.props.onClickedInvite({node: this.props.node, prId});

  }

  render() {

    let {
      left,
      top,
      canEditnode,
      node,
      nodeObj,
      onClickedInvite,
      stopStageClickPropagation,
      userTouchedNode,
      cursorBecomesMove,
      cursorBecomesPointer,
      mailIconDim,
      inviteContainerPaddingLeft,
      setFlipCardScreenIsOn,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
    } = this.props;

    let noEditPaddingLeft = ( !canEditnode({nodeObj}) ? 2 :0);
    if(isMobilePhone()) noEditPaddingLeft = 6;

    left += adjustLeft + noEditPaddingLeft + inviteContainerPaddingLeft - 1;
    top += adjustTop - 2.50;

    return (
        <Image
          image={this.props.invitationImage}
          scaleX={.1}
          scaleY={.1}
          width={mailIconDim.width * 10}
          height={mailIconDim.height * 10}
          opacity={.5}
          x={left}
          y={top}

          onClick={this.click.bind(this)}

          onTouchStart={()=>{

            userTouchedNode({
              node,
              callback: ()=>{

                if(isMobileTablet()){
                  stopStageClickPropagation({fromWhere: 'InviteComponent svg'});
                  const prId = nodeObj.pr_id;
                  onClickedInvite({node, prId});
                  return;
                }

                if(isMobilePhone() ) {
                  let screenIsOn = `mainFromHome`;
                  setFlipCardScreenIsOn({screenIsOn});
                  setNodeForFlipFocus(node);
                  setShowMobileFlipCard(node);
                }
              },
              fromWhere: 'invite svg'
            });

          }}

          onMouseenter={()=>{
            cursorBecomesPointer();
          }}

          onMouseleave={()=>{
            cursorBecomesMove();
          }}

        />
    );
  }
}

export class TransparentIconMail extends React.Component {

  render () {

      let {
        left,
        top,
        node,
        nodeObj,
        onClickedInvite,
        stopStageClickPropagation,
        userTouchedNode,
        cursorBecomesMove,
        cursorBecomesPointer,
        setFlipCardScreenIsOn,
        setNodeForFlipFocus,
        setShowMobileFlipCard,
      } = this.props;


    top += 23;
    left += 31
/*
              strokeWidth={.5}
              stroke={'black'}

 */
    return  <Rect
              x={left}
              y={top}
              width={7}
              height={8}
              cursor="pointer"



              onClick={(evt)=>{
                stopStageClickPropagation({fromWhere: 'InviteComponent C'});
                evt.cancelBubble = true;
                const prId = nodeObj.pr_id;
                onClickedInvite({node, prId});
              }}


              onTouchStart={()=>{

                userTouchedNode({
                  node,
                  callback: ()=>{

                    if(isMobileTablet()){
                      stopStageClickPropagation({fromWhere: 'InviteComponent D'});
                      const prId = nodeObj.pr_id;
                      onClickedInvite({node, prId});
                      return;
                    }

                    if(isMobilePhone() ) {
                      let screenIsOn = `mainFromHome`;
                      setFlipCardScreenIsOn({screenIsOn});
                      setNodeForFlipFocus(node);
                      setShowMobileFlipCard(node);
                    }
                  },
                  fromWhere: 'invite svg'
                });

              }}

              onMouseenter={()=>{
                cursorBecomesPointer();
              }}

              onMouseleave={()=>{
                cursorBecomesMove();
              }}


            />

  }
}


export const Label = ({
    n,
    node,
    nodeObj,
    left,
    top,
    canEditnode,
    onClickedInvite,
    cursorBecomesMove,
    cursorBecomesPointer,
    stopStageClickPropagation,
    userTouchedNode,
    panAnimateToNode,
    translatedLabels,
    inviteContainerPaddingLeft,
    mailIconDim,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
  }) => {

    const labelObj = translatedLabels.invite;

    let noEditPaddingLeft = ( !canEditnode({nodeObj}) ? 2 :0);
    if(isMobilePhone()) noEditPaddingLeft = 7;

    left += adjustLeft  + noEditPaddingLeft + inviteContainerPaddingLeft + mailIconDim.width;


    top += adjustTop - 2;

    return <Text
      x={left}
      y={top}
      text={labelObj.translatedLabel}
      fontSize={labelObj.labelFontSize}
      fill='gray'

      onClick={(evt)=>{
        stopStageClickPropagation({fromWhere: 'InviteComponent E'});
        evt.cancelBubble = true;
        const prId = nodeObj.pr_id;
        onClickedInvite({node, prId});
      }}

      onTouchStart={()=>{

        userTouchedNode({
          node,
          callback: ()=>{

            if(isMobileTablet()){
              stopStageClickPropagation({fromWhere: 'InviteComponent text'});
              const prId = nodeObj.pr_id;
              onClickedInvite({node, prId});
              return;
            }

            if(isMobilePhone() ) {
              let screenIsOn = `mainFromHome`;
              setFlipCardScreenIsOn({screenIsOn});
              setNodeForFlipFocus(node);
              setShowMobileFlipCard(node);
            }
          },
          fromWhere: 'invite text'
        });

      }}

      onMouseenter={()=>{
        cursorBecomesPointer();
      }}
      onMouseleave={()=>{
        cursorBecomesMove();
      }}

    />;
  };

